import { REHYDRATE } from 'redux-persist'

const initialState = {
  initiated: false,
}

// eslint-disable-next-line default-param-last
const rehydrate = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        initiated: true,
      }
    default:
      return state
  }
}

export default rehydrate
